/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { TtadondutyrequestdtlItem } from '../../models/TtadondutyrequestdtlItem';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `TtadondutyrequestdtlItem` model.
 */
@Injectable()
export class TtadondutyrequestdtlItemApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} sffilter 
   *
   * @param {object} auth 
   *
   * @param {object} req 
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFfind(sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFfind";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Find first instance of the model matched by filter from the data source.
   *
   * @param {object} sffilter 
   *
   * @param {object} auth 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFfindOne(sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFfindOne";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Count instances of the model matched by where from the data source.
   *
   * @param {object} sfwhere 
   *
   * @param {object} auth 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `count` – `{number}` - 
   */
  public SFcount(sfwhere: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFcount";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Find a model instance by {{id}} from the data source.
   *
   * @param {any} id Model id
   *
   * @param {object} sffilter Filter defining fields and include
   *
   * @param {object} auth 
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFfindById(id: any, sffilter: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFfindById:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof sffilter !== 'undefined' && sffilter !== null) _urlParams.sffilter = sffilter;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Create a new instance of the model and persist it into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `sfdata` – `{object}` - Model instance data
   *
   *  - `auth` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFcreate(sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFcreate";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `sfdata` – `{object}` - Model instance data
   *
   *  - `auth` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFupsert(sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<TtadondutyrequestdtlItem> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFupsert";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result.map((instance: TtadondutyrequestdtlItem) => new TtadondutyrequestdtlItem(instance));
  }

  /**
   * Update an existing model instance or insert a new one into the data source based on the where criteria.
   *
   * @param {object} sfwhere Criteria to match model instances
   *
   * @param {object} data Request data.
   *
   *  - `sfdata` – `{object}` - An object of model property name/value pairs
   *
   *  - `auth` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFupsertWithWhere(sfwhere: any = {}, sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<TtadondutyrequestdtlItem> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFupsertWithWhere";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result.map((instance: TtadondutyrequestdtlItem) => new TtadondutyrequestdtlItem(instance));
  }

  /**
   * Update instances of the model matched by {{where}} from the data source.
   *
   * @param {object} sfwhere Criteria to match model instances
   *
   * @param {object} data Request data.
   *
   *  - `sfdata` – `{object}` - An object of model property name/value pairs
   *
   *  - `auth` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Information related to the outcome of the operation
   */
  public SFupdateAll(sfwhere: any = {}, sfdata: any = {}, auth: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/SFupdate";
    let _routeParams: any = {};
    let _postBody: any = {
      sfdata: sfdata
    };
    let _urlParams: any = {};
    if (typeof sfwhere !== 'undefined' && sfwhere !== null) _urlParams.sfwhere = sfwhere;
    if (typeof auth !== 'undefined' && auth !== null) _urlParams.auth = auth;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Delete a model instance by {{id}} from the data source.
   *
   * @param {any} id Model id
   *
   * @param {object} req 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `TtadondutyrequestdtlItem` object.)
   * </em>
   */
  public SFdeleteById(id: any, customHeaders?: Function): Observable<any> {
    let _method: string = "DELETE";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/TtadondutyrequestdtlItems/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `TtadondutyrequestdtlItem`.
   */
  public getModelName() {
    return "TtadondutyrequestdtlItem";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/TtadondutyrequestdtlItem.ts